import React from 'react';
import { 
  Box, 
  Typography, 
  Container, 
  Grid, 
  Paper,
  styled 
} from '@mui/material';
import { Search, MessageSquare, BarChart3, Database } from 'lucide-react';

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: '#0d9488',
  color: 'white',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: theme.shadows[8]
  }
}));

const IconWrapper = styled(Box)({
  marginBottom: '1rem',
  '& > svg': {
    strokeWidth: 1.5
  }
});

const FeatureTile = ({ icon: Icon, title, description }) => {
  return (
    <StyledPaper elevation={4}>
      <IconWrapper>
        <Icon size={32} />
      </IconWrapper>
      <Typography 
        variant="h6" 
        component="h3" 
        sx={{ 
          fontWeight: 600,
          mb: 1
        }}
      >
        {title}
      </Typography>
      <Typography 
        sx={{ 
          opacity: 0.9,
          flex: 1
        }}
      >
        {description}
      </Typography>
    </StyledPaper>
  );
};

const FeaturesSection = () => {
  const features = [
    {
      icon: Search,
      title: "Search Widget",
      description: "Powerful search functionality that understands user intent and delivers accurate results"
    },
    {
      icon: MessageSquare,
      title: "Chat Widget",
      description: "Interactive chat interface for real-time customer support and engagement"
    },
    {
      icon: Database,
      title: "Data Pipeline",
      description: "Efficient data processing and organization for optimal search performance"
    },
    {
      icon: BarChart3,
      title: "Analytics Dashboard",
      description: "Comprehensive tracking of search and conversation metrics"
    }
  ];

  return (
    <Box 
      component="section" 
      id="features"
      sx={{
        py: 8,
        bgcolor: 'background.paper'
      }}
    >
      <Container>
        <Typography 
          variant="h3" 
          component="h2"
          align="center"
          sx={{
            color: '#0d9488',
            fontWeight: 700,
            mb: 6
          }}
        >
          Features That Drive Results
        </Typography>
        
        <Grid container spacing={4}>
          {features.map((feature, index) => (
            <Grid item xs={12} md={6} lg={3} key={index}>
              <FeatureTile {...feature} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default FeaturesSection;